export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";